import React from 'react';
import {Carousel, Image} from 'react-bootstrap';
import './Slider.css';
function Slider() {
    return (
        <div className='slider' id='slider'>
            <Carousel className='slider__carousel'>
                <Carousel.Item>
                    <Image
                    className="d-block w-100  image"
                    src="/images/stracture.jpg"
                    alt="First slide"
                    fluid
                    />
                    {/* <Carousel.Caption>
                    <h3>First slide label</h3>
                    <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                    </Carousel.Caption> */}
                </Carousel.Item>
                
                <Carousel.Item>
                    <Image
                    className="d-block w-100  image"
                    src="/images/hygine.jpg"
                    alt="First slide"
                    fluid
                    />

                    
                </Carousel.Item>
                
                <Carousel.Item>
                    <Image
                    className="d-block w-100 fluid image"
                    src="/images/client.jpg"
                    alt="First slide"
                    fluid
                    />

                    
                </Carousel.Item>
            </Carousel>
        </div>
);
}

export default Slider;
